module.exports = {
	"development": {
		"standardproduct-server": "http://localhost:3005"
	},
	"uat": {
		"standardproduct-server": "https://backoffice-products-integration.esf-plus.com"
	},
	"integration": {
		"standardproduct-server": "https://backoffice-products-integration.esf-plus.com"
	},
	"production": {
		"standardproduct-server": "https://backoffice-products.esf-plus.com"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 1072
// module chunks = 0